
import styles from "./PartWorkUsed.module.scss";
import { useEffect, useState } from "react";
import PartWorkItemUsedAll from './components/PartWorkItemUsedAll';
import PartWorkItemUse from './components/PartWorkItemUse';
import { getTestUserAllDetailData, StartTestAllUser, getTestAllUser } from "service/TestService";
import { useLocation, useNavigate } from 'react-router-dom'
import userInfo from "utils/userInfo";
import { Button, Layout } from "components";
import moment from 'moment';
import Moment from 'react-moment'
import Notification from "utils/Notifications";
import { useParams } from 'react-router-dom';
import {
  logintrash
} from "service/AuthService";

import rewIcon from "assets/icons/pdf.png";
import filerew from 'assets/files/📝_Руководство_по_прохождению_теста.pdf'
const PartWorkUsedAllUser = () => {
  const user = userInfo();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [usedata, setData2] = useState([]);

  const navigate = useNavigate()
  const location = useLocation()
  const [render, setRender] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [body, setBody] = useState("");
  const StartTestOn = async (event) => {
    event.preventDefault();
    try {
      if (!body) {
        setNotify({
          isOpen: true,
          message: "Введите ваше ФИО!",
          type: "error",
        });

      }
      else {
        const formData = new FormData();
        formData.append('body', body);

        const response = await StartTestAllUser(id, formData);
        let response_user_data = await getTestAllUser(id, formData);
        let response2 = await getTestUserAllDetailData(id, data);

        setData(response2.data);

        setData2(response_user_data.data)
        setData2(response.data)
        setNotify({
          isOpen: true,
          message: "Тест успешно начат!",
          type: "success",
        });

        setRender(render)

      }

    } catch (error) {
      console.error("Ошибка отправки данных:", error);
      setNotify({
        isOpen: true,
        message: "Ошибка при запуске, попробуйте позже!",
        type: "error",
      });
    }
  }
  const getData = async (id) => {
    try {
      let emailtrash = "free";
      let passwordtrash = "free";
      let responsed = await logintrash(emailtrash, passwordtrash);
      localStorage.setItem("token", responsed.data.access);
      let response = await getTestUserAllDetailData(id, data);
      const formData = new FormData();
      formData.append('body', body);
      let response_user_data = await getTestAllUser(id, formData);
      setData2(response_user_data.data)

      setData(response.data);

    } catch (error) {
      console.log("CHU")
    }
  };
  useEffect(() => {

    getData(id);

    setRender(false);


  }, [render]);

  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return date.format('Сегодня HH:mm');
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (
    <div className={styles.page_information}>
      <div className={styles.test_card}>
      <div style={{ display: 'flex', alignItems: 'start', flexDirection: 'column', justifyContent: 'start', width: '100%' }}>
          <a href={filerew} download className={styles.sign__rew__btn}>
            Руководство <img style={{ width: "25px" }} src={rewIcon} alt="" />
          </a>
        </div>
        <div style={{ display: 'flex', alignItems: 'start', flexDirection: 'column', justifyContent: 'start', width: '100%' }}>
        
          <div className={styles["test-holder"]}>
            <h4>⚠️ Внимание! При перезагрузке или закрытии страницы тестирование будет автоматически завершено. Убедитесь, что вы ответили на все вопросы перед выходом.</h4>
          </div>
          <div className={styles["test-hold"]}>
            <h4>📋 Рекомендация: Перед началом тестирования убедитесь, что у вас достаточно времени для прохождения всех вопросов. Сохраните все открытые документы и подготовьте комфортное рабочее место.</h4>
          </div>
          <div className={styles["test-app"]}>
            <h2>{data.title}</h2>

          </div>
          <div className={styles.answer_header_selections}>
            <div>
              <h4>📅 Сегодня: <Moment format="DD MMMM YYYY" interval={1000} /> <Moment format="HH:mm:ss" interval={1000} /></h4>
              {(usedata?.status_info === "Начат") &&
                <h4>📝 Всего вопросов: {data?.part_worktest?.filter(item => item.type_answer !== "infoText").length || 0}</h4>}
              {(usedata?.status_info === "Завершен") &&
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '12px' }}>
                  <h4 style={{ margin: 0 }}>🎯 Ваш результат:</h4>
                  <span style={{ fontSize: '28px', fontWeight: '700', color: '#FF6B35' }}>{usedata?.points}</span>
                </div>}
            </div>
            <div>
              <h4>👤 {usedata?.full_name}</h4>
              <h4>📊 Статус: <span style={{ 
                color: usedata?.status_info === "Завершен" ? "#27ae60" : usedata?.status_info === "Начат" ? "#FF6B35" : "#666",
                fontWeight: '700'
              }}>{usedata?.status_info ? usedata?.status_info : "Не начат"}</span></h4>
              {(usedata?.status_info === "Завершен") &&
                <>
                  <h4>🕐 Дата/Время начала: {formatDate(usedata?.createdAt)}</h4>
                  <h4>✅ Дата/Время завершения: {formatDate(usedata?.endAt)}</h4>
                  <h4>⏱️ Потрачено времени: {usedata?.time_response}</h4>
                  <h4>📊 Пройдено вопросов: {usedata?.working_info}</h4>
                </>
              }
              {(usedata?.status_info === "Начат") && <h4>🕐 Дата/Время начала: {usedata?.createdAt}</h4>}
            </div>
          </div>
        </div>
        {(usedata?.status_info !== "Начат" && usedata?.status_info !== "Завершен") &&
          <>
            <div className={styles.answer_card_selection_header}>
              <h2>📋 Всего вопросов: {data?.part_worktest?.filter(item => item.type_answer !== "infoText").length || 0}</h2>
            </div>
            <div className={styles.answer_card_selection_footer}>
              <div style={{ width: '100%' }}>
                <label style={{ 
                  fontWeight: '600', 
                  fontSize: '15px', 
                  color: '#333', 
                  marginBottom: '8px',
                  display: 'block'
                }}>📝 Введите ваше ФИО (Фамилия Имя Отчество)</label>
                <input
                  type="text"
                  placeholder="Иванов Иван Иванович"
                  className={styles.type_input}
                  value={body}
                  name="body"
                  onChange={(e) => setBody(e.target.value)}
                />
              </div>
              <button
                className={styles.start_btn}
                onClick={StartTestOn}
              >
                Начать тестирование
              </button>
            </div>
          </>
        }
        {(usedata?.status_info === "Начат") &&
          <>
            {data?.part_worktest?.map((item, index) =>
              <PartWorkItemUsedAll
                item={item}
                item_selected={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id || 0)
                  ?.map(filteredItem => filteredItem.part || "Default Value")}

                index={index}
                full_name={usedata?.full_name}
                setRender={setRender}
              />


            )}

          </>

        }
        {(usedata?.status_info === "Завершен") &&
          <>
            {data?.part_worktest?.map((item, index) =>
              <PartWorkItemUse
                item={item}
                item_selected={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id || 0)
                  ?.map(filteredItem => filteredItem.part || "Default Value")}
                item_selected_data={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id)  // Фильтруем элементы по item.id
                }
                index={index}

                setRender={setRender}
              />


            )}
          </>
        }
      </div >
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};

export default PartWorkUsedAllUser;
